import { getAppStore } from '../appStoreRef';
import type { AppStateType } from '../types';
import { countrySelector } from '../intl/selectors';
import {
  defaultFeaturesSelector,
  qaFeaturesSelector,
  regionalFeaturesSelector,
  tokenFeaturesSelector,
} from './selectors';
import { AppFeatureName, getIsFeatureVisible } from './utils';

export const isFeatureEnabled = (featureName: AppFeatureName) => {
  const store = getAppStore();

  if (!store) {
    throw new Error(
      'App store not initialized. Ensure AppWrapper is mounted before calling isFeatureEnabled.',
    );
  }

  const state = store.getState() as AppStateType;

  return getIsFeatureVisible({
    countryCode: countrySelector(state),
    featureName,
    defaultFeatures: defaultFeaturesSelector(state),
    regionalFeatures: regionalFeaturesSelector(state),
    tokenFeatures: tokenFeaturesSelector(state),
    qaFeatures: qaFeaturesSelector(state),
  });
};

// Safe variant for pre-login / module-scope callers that may run before
// AppWrapper has initialised the Redux store. Returns `false` instead of
// throwing so callers can fall back to store-independent logic.
export const isFeatureEnabledSafe = (featureName: AppFeatureName): boolean => {
  try {
    return isFeatureEnabled(featureName);
  } catch {
    return false;
  }
};
